import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsage_Update_Mutation = graphql(`
  mutation ResolvableMissionTypeForm_ServiceUsage_Update(
    $serviceUsageId: Id!
    $serviceUserId: Id!
    $serviceUsagesGroupId: Id!
    $update: ResolvableServiceUsageInput!
    $versionData: VersionDataInput
  ) {
    updateResolvableMissionTypeServiceUsage(
      serviceUsageId: $serviceUsageId
      serviceUserId: $serviceUserId
      serviceUsagesGroupId: $serviceUsagesGroupId
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateResolvableMissionTypeServiceUsageMutation = () =>
  useGraphQLMutation(ResolvableMissionTypeForm_ServiceUsage_Update_Mutation);
